// Helpers
import useI18n, { LocaleTypes } from '@i18n';

const TextByLocale: React.FC = () => {
    const { locale } = useI18n();

    if (locale === LocaleTypes.ru) {
        return (
            <div className="text-blueGray-800">
                <div className="pb-8 text-p1">
                    <strong>Что такое ePN</strong>

                    <p>
                        Это CPA-платформа, выступающая посредником между рекламодателями и
                        вебмастерами. Мы работаем только по белым схемам и обеспечиваем удобные и
                        выгодные условия всем участникам сделки. <br />
                        Наша команда работает в аффилированном маркетинге с 2013 года. Сеть ePN
                        создана профессионалами и ежедневно опытные разработчики трудятся над ее
                        совершенствованием. <br />
                    </p>
                </div>

                <div className="pb-8 text-p1">
                    <strong>Как работает CPA-маркетинг</strong>

                    <p>
                        Cost per action (англ. - оплата за действия) - партнерская программа с
                        оплатой за действия. Вариант сотрудничества между продавцом и его партнерами
                        (ими могут быть вебмастера, представители интернет-проектов, арбитражники),
                        которые направляют трафик на ресурс продавца. <br />
                        Выбирая модель CPA-продвижения, рекламодатель платит за конкретные действия
                        пользователей, привлеченных вебмастерами. В ePN рекламодатели платят только
                        за совершенную покупку, что защищает вас от оплаты нецелевого трафика.
                    </p>
                </div>

                <div className="pb-8 text-p1">
                    <strong>Как работает CPA для рекламодателей</strong>

                    <ul>
                        <li>- вы размещаете свой оффер в нашей системе </li>
                        <li>- вебмастера направляют трафик на ваш ресурс</li>
                        <li>- привлеченные пользователи покупают ваш товар (целевое действие)</li>
                        <li>- вы оплачиваете совершенное целевое действие cpa-системе</li>
                        <li>- cpa-система оплачивает действие вебмастеру</li>
                        <li>- все участники сделки получают желаемое</li>
                    </ul>
                </div>

                <div className="pb-8 text-p1">
                    <strong>Откуда приходит трафик в магазин рекламодателя</strong>
                    <p>
                        Для привлечения трафика на вашу площадку вебмастера могут использовать самые
                        разные источники:
                    </p>
                    <br /> <br />
                    <ul>
                        <li>1. Тематические сайты</li>
                        <li>2. Баннерная реклама</li>
                        <li>3. Тизерная реклама</li>
                        <li>4. Таргетированная реклама в социальных сетях</li>
                        <li>5. Приложения и игры в социальных сетях</li>
                        <li>6. Группы в социальных сетях</li>
                        <li>7. Мобильные приложения</li>
                        <li>8. Cashback</li>
                        <li>9. Контекстная реклама</li>
                        <li>10. E-mail и SMS - рассылки</li>
                    </ul>
                </div>

                <div className="pb-8 text-p1">
                    <p>
                        Требования к категориям трафика оговариваются условиями вашего оффера. Если,
                        к примеру, пользователи игр в социальных сетях - не ваша аудитория, этот
                        источник трафика будет запрещен в вашем оффере.
                    </p>
                </div>

                <div className="pb-8 text-p1">
                    <strong>Почему ePN</strong>

                    <p>
                        Наша платформа зарекомендовала себя как удобная площадка для работы
                        профессионалов. Качество и надежность нашей cpa-системы оценили более 700
                        000 вебмастеров со всего мира. Мы всегда открыты к сотрудничеству с новыми
                        рекламодателями.
                    </p>
                </div>

                <div className="pb-8 text-p1">
                    <strong>Преимущества для рекламодателей</strong>
                    <p>
                        ePN полностью берет на себя взаимодействие с вебмастерами. Мы сами делаем
                        выплаты партнерских вознаграждений. Оказываем техподдержку и консультируем
                        вебмастеров по интеграции ваших промо-материалов на их площадках. А
                        рекламодатель получает целый набор удобных инструментов для CPA-рекламы:
                    </p>

                    <ul>
                        <li>
                            - Доступ к функциональному личному кабинету, с помощью которого вы
                            можете контролировать все действия, за которые платите.
                        </li>
                        <li>- Встроенную антифрод систему, позволяющая избежать накруток.</li>
                        <li>- Опыт и экспертиза специалистов</li>
                        <li>- Техподдержка на русском, английском и испанском.</li>
                        <li>
                            - Прозрачная и понятная система взаимодействия всех участников сделки.
                        </li>
                        <li>- База из 700 000 вебмастеров.</li>
                        <li>- Детальная статистика по офферам в режиме реального времени.</li>
                        <li>
                            - Кэшбэк сервис, через который совершается около миллиона продаж в
                            месяц.
                        </li>
                    </ul>
                </div>

                <div className="pb-8 text-p1">
                    <strong>Как стать нашим партнером</strong>

                    <ul>
                        <li>1. Заполните специальную форму для связи.</li>
                        <li>
                            2. Наши специалисты помогут вам выбрать оптимальные тарифы и виды
                            трафика.
                        </li>
                        <li>3. Запускаем вашу партнерскую программу.</li>
                    </ul>
                </div>

                <div className="pb-8 text-p1">
                    <p>
                        Став нашим рекламодателем, вы получаете в партнеры тысячи лучших вебмастеров
                        со всего мира. Выбирая ePN, вы получаете доступ к самым современным и
                        эффективным инструментам CPA-рекламы.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="text-blueGray-800">
            <div className="pb-8 text-p1">
                <strong>What is e-Commerce Partners Network</strong>

                <p>
                    This is a CPA-platform, acting as an intermediary between advertisers and
                    webmasters. We work only on white schemes and provide convenient and beneficial
                    terms for all bidders. <br />
                    The network e-Commerce Partners Network is created by professionals and every
                    day experienced developers work on its improvement. <br />
                </p>
            </div>

            <div className="pb-8 text-p1">
                <strong>How CPA Marketing Works</strong>

                <p>
                    Cost per action - affiliate program with payment for actions. The option of
                    cooperation between the seller and his partners (they can be webmasters,
                    representatives of Internet projects, arbitrators), which direct traffic to the
                    sellers resource. <br />
                    Choosing a CPA-promotion model, the advertiser pays for specific actions of
                    users attracted by webmasters. In e-Commerce Partners Network, advertisers pay
                    only for a perfect purchase, which protects you from paying for un-targeted
                    traffic.
                </p>
            </div>

            <div className="pb-8 text-p1">
                <strong>How CPA works for advertisers</strong>

                <ul>
                    <li>- you place your offer in our system</li>
                    <li>- webmasters send traffic to your site</li>
                    <li>- attracted users buy your product (target action)</li>
                    <li>- you pay the perfect target action to the cpa-system</li>
                    <li>- cpa-system pays for action to webmaster</li>
                    <li>- all participants in the transaction receive the desired</li>
                </ul>
            </div>

            <div className="pb-8 text-p1">
                <strong>From where traffic comes to the advertisers store</strong>

                <p>To attract traffic to your site, webmasters can use a variety of sources:</p>

                <ul>
                    <li>1. Thematic sites</li>
                    <li>2. Banner advertising</li>
                    <li>3. Teaser advertising</li>
                    <li>4. Targeted advertising in social networks</li>
                    <li>5. Applications and games in social networks</li>
                    <li>6. Groups in social networks</li>
                    <li>7. Mobile applications</li>
                    <li>8. Cashback</li>
                    <li>9. contextual advertising</li>
                    <li>10. E-mail and SMS</li>
                </ul>

                <p>
                    Requirements for traffic categories are stipulated by the terms of your offer.
                    If, for example, users of games in social networks - not your audience, this
                    source of traffic will be banned in your account.
                </p>
            </div>

            <div className="pb-8 text-p1">
                <strong>Why e-Commerce Partners Network</strong>

                <p>
                    Our platform is convenient for professionals to work with. We are always open to
                    cooperation with new advertisers.
                </p>
            </div>

            <div className="pb-8 text-p1">
                <strong>Advantages for advertisers</strong>

                <p>
                    e-Commerce Partners Network completely takes care of interaction with
                    webmasters. We make payments of partner rewards ourselves. We provide technical
                    support and advise webmasters on the integration of your promotional materials
                    on their sites. <br />
                    And the advertiser gets a whole set of convenient tools for CPA-advertising:
                </p>

                <ul>
                    <li>
                        - Access to a functional personal cabinet, through which you can monitor all
                        actions for which you pay.
                    </li>
                    <li>- Built-in antifrood system, which allows you to avoid cheating.</li>
                    <li>- Experience and expertise of specialists</li>
                    <li>
                        - Transparent and understandable system of interaction of all participants
                        in the transaction.
                    </li>
                    <li>- Detailed statistics on the off-line in real time.</li>
                    <li>- Cashback service, through which about a million sales per month.</li>
                </ul>
            </div>

            <div className="pb-8 text-p1">
                <strong>How to become our partner</strong>

                <ul>
                    <li>1. Fill out the special form for communication.</li>
                    <li>
                        2. Our specialists will help you to choose the optimal tariffs and types of
                        traffic.
                    </li>
                    <li>3. Run your affiliate program.</li>
                </ul>

                <br />
                <br />

                <p>
                    Becoming our advertiser, you get to partners thousands of the best webmasters
                    from around the world. Choosing e-Commerce Partners Network, you get access to
                    the most modern and effective tools for CPA-advertising.
                </p>
            </div>
        </div>
    );
};

export default TextByLocale;
